import { CategoryGrouping } from '../types';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import teamGroupings from './teams';
import individualGroupings from './individual';
import { PackageType } from '~shared/types/pricing/package';

import GROW_2529_INDIVIDUAL_GROUPINGS from '~pricing/experiments/grow_2529_forms/transformers/details/groupings/individual';

const categoryGroupings: CategoryGrouping = {
  [PackageType.Teams]: {
    default: teamGroupings,
  },
  [PackageType.Details]: {
    default: teamGroupings,
  },
  [PackageType.Individual]: {
    default: individualGroupings,
    [EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1]: GROW_2529_INDIVIDUAL_GROUPINGS,
    [EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment2]: GROW_2529_INDIVIDUAL_GROUPINGS,
    [EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.treatment]: GROW_2529_INDIVIDUAL_GROUPINGS,
  },
  [PackageType.Educational]: {
    default: individualGroupings,
  },
};

export default categoryGroupings;
